import { render, staticRenderFns } from "./InventoryReceipt.vue?vue&type=template&id=c96d2fbe&scoped=true"
import script from "./InventoryReceipt.vue?vue&type=script&lang=js"
export * from "./InventoryReceipt.vue?vue&type=script&lang=js"
import style0 from "./InventoryReceipt.vue?vue&type=style&index=0&id=c96d2fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96d2fbe",
  null
  
)

export default component.exports